module.exports = __webpack_public_path__ + "static/gensonos/media/logo.71aee7f2.svg";